const TipoSuelo = Object.freeze({
  NORMAL: 1,
  HIDROPONIA: 2,
});

export default TipoSuelo;